import {
  ausschreibungsdiensteSubmenuData,
  baumagazinSubmenuData,
  evergabeSubmenuData,
  fachzeitschriftenSubmenuData,
  galabauSubmenuData,
  ueberUnsSubmenuData,
  umweltbauSubmenuData,
  vergabeWissenSubmenuData,
} from "./submenu-data"

export const getSubmenuData = {
  ausschreibungsdienste: ausschreibungsdiensteSubmenuData,
  baumagazin: baumagazinSubmenuData,
  evergabe: evergabeSubmenuData,
  fachzeitschriften: fachzeitschriftenSubmenuData,
  galabau: galabauSubmenuData,
  "ueber-uns": ueberUnsSubmenuData,
  umweltbau: umweltbauSubmenuData,
  "vergabe-wissen": vergabeWissenSubmenuData,
}
